const ESSENTIALS = [
  {
    label: "Rent/Mortgage",
    value: "rent/mortgage"
  },
  {
    label: "Groceries",
    value: "groceries"
  },
  {
    label: "Utilities",
    value: "utilities"
  },
  {
    label: "Gasoline/Fuel",
    value: "gasoline/fuel"
  }
];

export const ESSENTIALS_LABELS = ESSENTIALS.reduce((prev, next) => {
  prev[next.value] = next.label;

  return prev;
}, {});

export default ESSENTIALS;
